<template>
    <div class="secondary-dialog">
        <el-dialog
            :visible.sync="visible"
            :title="$t('Sell.change_validity')" left>
            <el-form
                ref="form"
                :model="form"
                label-suffix=":"
                label-width="120px"
                :rules="rules"
                label-position="right">
                <el-form-item :label="$t('Sell.Dialog.old_validity')">
                    {{ `${clientInfo.startAt} ~ ${clientInfo.endAt}` }}
                </el-form-item>
                <el-form-item :label="$t('Sell.Dialog.change_into')" prop="date">
                    <el-date-picker
                        style="width: 300px"
                        v-model="form.date"
                        type="daterange"
                        :range-separator="$t('Reception.Third.zhi')"
                        value-format="yyyy-MM-dd"
                        :start-placeholder="$t('Common.start_time')"
                        :end-placeholder="$t('Common.end_time')">
                    </el-date-picker>
                </el-form-item>
                <el-form-item :label="$t('Common.remark')">
                    <el-input
                        style="width: 300px"
                        type="textarea"
                        rows="6"
                        v-model="form.remark" />
                </el-form-item>
            </el-form>
            <div class="text-center">
                <el-button
                    @click="submit"
                    type="primary">
                    {{ $t('Message.confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { Dialog, DatePicker } from 'element-ui';

export default {
    components: {
        ElDialog: Dialog,
        ElDatePicker: DatePicker,
    },
    // member personal locker cardsCon-储值卡合同管理
    props: ['activeName'],
    data() {
        return {
            visible: false,
            contractNum: null,
            clientInfo: {},
            form: {
                startAt: null,
                endAt: null,
                remark: null,
                date: null,
            },
            rules: {
                date: { required: true, message: this.$t('Sell.Time.start') },
            },
            type: null,
        };
    },
    watch: {
        'visible'(val) {
            if (!val) this.resetForm();
        },
    },
    methods: {
        resetForm() {
            this.form = {
                startAt: null,
                endAt: null,
                remark: null,
                date: null,
            };
            setTimeout(() => {
                this.$refs.form.resetFields();
            }, 0);
        },
        handleUrl() {
            if (this.activeName === 'member') this.type = 'mshp';
            else if (this.activeName === 'personal') this.type = 'coach';
            else if (this.activeName === 'locker') this.type = 'locker';
            else if (this.activeName === 'cardsCon') this.type = 'cz-card';
        },
        open(data) {
            if (data.activeCardWayCode === 2 && !data.validity)
                return $ele.$message(this.$t('Sell.Dialog.tip2'));

            this.contractNum = data.contractNum;
            this.handleUrl();
            this.fetchData();
        },
        fetchData() {
            API.get(`contract/${this.type}/${this.contractNum}`)
            .then(res => {
                this.clientInfo = res;
                this.visible = true;
            });
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                this.form.startAt = this.form.date[0];
                this.form.endAt = this.form.date[1];
                this.postData();
            });
        },
        postData() {
            const form = Object.assign({}, this.form);
            delete form.date;
            API.post(`contract/${this.type}/${this.contractNum}/validity`, form)
            .then(() => {
                $ele.$message.success(this.$t('Message.success'));
                this.visible = false;
                this.$emit('fetchData');
            });
        },
    },
};
</script>
<style lang="scss">
.secondary-dialog {
    .el-dialog {
        width: 710px;
    }
    .el-range-separator {
        width: auto;
    }
}
.secondary-form-item {
    .el-form-item__label {
        width: 100% !important;
        text-align: left !important;
    }
    .el-radio {
        width: 70%;
        margin-left: 0 !important;
        margin-bottom: 10px;

        &:last-child {
            margin-bottom: 0;
        }
    }
    .el-radio__label {
        font-size: 12px !important;
    }
    .el-form-item__content {
        margin-left: 0 !important;
    }
}
.secondary-radio-bg {
    background: #f7f7f7;
    padding: 15px 40px;
    margin-top: 50px;
}
</style>
